import { FC } from "react"
import { FieldProps } from "@rjsf/core"
import { CommonParameter } from "./CommonParameter"

export const FieldParameter: FC<FieldProps> = ({
    formData,
    registry,
    idSchema,
    onChange,
    errorSchema,
    onBlur,
    onFocus,
    uiSchema,
    required,
    readonly,
    autofocus,
    schema,
    name,
    rawErrors
}) => {
    const SchemaField = registry.fields.SchemaField

    return (
        <CommonParameter
            title={schema.title}
            description={schema.description}
            required={required}
        >
            <SchemaField
                name={name}
                formContext={{}}
                idPrefix={{}}
                errorSchema={
                    rawErrors
                        ? {
                              __errors: rawErrors
                          }
                        : errorSchema
                }
                autofocus={autofocus}
                readonly={readonly}
                required={required}
                uiSchema={{
                    ...uiSchema,
                    "ui:field": undefined
                }}
                idSchema={idSchema}
                formData={formData}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
                registry={registry}
                disabled={false}
                schema={{
                    ...schema,
                    title: "",
                    description: ""
                }}
            />
        </CommonParameter>
    )
}
